/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Toast_Deleted_ManyInputs */

const en_toast_deleted_many = /** @type {(inputs: Toast_Deleted_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} items moved to the trash`)
};

const de_toast_deleted_many = /** @type {(inputs: Toast_Deleted_ManyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Vorgänge in den Papierkorb verschoben`)
};

/**
* | output |
* | --- |
* | "{count} items moved to the trash" |
*
* @param {Toast_Deleted_ManyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const toast_deleted_many = /** @type {((inputs: Toast_Deleted_ManyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Deleted_ManyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_toast_deleted_many(inputs)
	return en_toast_deleted_many(inputs)
});